import * as React from 'react'

import DropArea from './components/drop-area'
import FileViewer from './components/file-viewer'
import { AttachmentModel } from './domain/model'
import { useAttachmentTranslations } from '.'

interface Props {
  authProfile: string
  attachmentApiUrl: string
  models: AttachmentModel[]
  onAdd: (files: FileList) => void
  onDelete: (model: AttachmentModel) => void
  dataQa?: string
}

export const AttachmentSelector: React.FC<Props> = (p: Props) => {
  const i18nScope = useAttachmentTranslations()
  return (
    <div className="upload-box" data-qa={p.dataQa}>
      {p.models.length > 0 ? (
        <FileViewer
          models={p.models}
          onDelete={p.onDelete}
          authProfile={p.authProfile}
          attachmentApiUrl={p.attachmentApiUrl}
          translations={i18nScope}
        />
      ) : null}
      <DropArea onAdd={p.onAdd} translations={i18nScope} />
    </div>
  )
}
